<template>
  <div class="page page__content-wrapper">

    <div class="page__full-width souvenir-full">
      <div class="page__min-container souvenir-min-margin">
        <div class="text__head">
          <div class="top-border"></div>
          Кружки
        </div>
      </div>
      <div class="page__link-block">
        <a :href="cup.urlZip"
           @click.prevent="downloadItemZip(cup)"
           class="btn__circle btn__nav-slider btn-download">
          <img src="~assets/img/icons/icon-zip.svg" alt="ZIP">
        </a>
      </div>
    </div>
    <div class="page__full-width souvenir-full cup-block">
      <div class="page__min-container">
        <div class="text__normal">
          <span class="blue">Белая кружка</span><br>
          Круговая УФ-печать. Также допускается печать методом сублимации
        </div>
      </div>
    </div>
    <div class="page__full-width souvenir-full cup-block">
      <div class="page__min-container">
        <div class="text__normal">
          <span class="blue">Синяя кружка</span><br>
          Нанесение цвета технологией деколирования. При отсутствии такой возможности производится нанесение только логотипа технологией сублимации на кружку синего оттенка, близкого к фирменному «Midnight Blue»
        </div>
      </div>
    </div>
    <div class="page__full-width souvenir-full">
      <div class="page__min-container" style="margin-bottom: 0;">
        <div class="page__img-wrapper">
          <img src="~assets/img/souvenir-page/souvenier-1.png" alt="">
        </div>
      </div>
    </div>
    <div class="page__full-width souvenir-full ">
      <div class="page__min-container  souvenir-min-margin">
        <div class="text__head">
          <div class="top-border"></div>
          Блокнот
        </div>
      </div>
      <div class="page__link-block download-block">
        <a :href="notebook.urlZip"
           @click.prevent="downloadItemZip(notebook)"
           class="btn__circle btn__nav-slider btn-download">
          <img src="~assets/img/icons/icon-ai.svg" alt="ZIP">
        </a>
      </div>
    </div>
    <div class="page__full-width souvenir-full">
      <div class="page__min-container">
        <div class="text__normal">
          Полноцветная цифровая печать, матовая ламинация для защиты от царапин<br>
          Внутренний блок разлинован<br>
          Обложка из картона плотностью от 600 г/м<sup>2</sup>
        </div>
      </div>
    </div>
    <div class="page__full-width souvenir-full">
      <div class="page__min-container" style="margin-bottom: 0px;">
        <div class="page__img-wrapper">
          <img src="~assets/img/souvenir-page/souvenier-2.png" alt="">
        </div>
      </div>
    </div>
    <div class="page__full-width souvenir-full">
      <div class="page__min-container souvenir-min-margin">
        <div class="text__head">
          <div class="top-border"></div>
          USB-накопитель
        </div>
      </div>
      <div class="page__link-block download-block">
        <a :href="usb.urlZip"
           @click.prevent="downloadItemZip(usb)"
           class="btn__circle btn__nav-slider btn-download">
          <img src="~assets/img/icons/icon-ai.svg" alt="ZIP">
        </a>
      </div>
    </div>
    <div class="page__full-width souvenir-full">
      <div class="page__min-container">
        <div class="text__normal">
          USB 3.0 <br>
          От 32 GB <br>
          Формат файловой системы: exFat <br>
          УФ-печать
        </div>
      </div>
    </div>
    <div class="page__full-width souvenir-full">
      <div class="page__min-container" style="margin-bottom: 0px;">
        <div class="page__img-wrapper">
          <img src="~assets/img/souvenir-page/souvenier-3.png" alt="">
        </div>
      </div>
    </div>
    <div class="page__full-width souvenir-full">
      <div class="page__min-container souvenir-min-margin">
        <div class="text__head">
          <div class="top-border"></div>
          Ручка
        </div>
      </div>
      <div class="page__link-block download-block">
        <a :href="pen.urlZip"
           @click.prevent="downloadItemZip(pen)"
           class="btn__circle btn__nav-slider btn-download">
          <img src="~assets/img/icons/icon-ai.svg" alt="ZIP">
        </a>
      </div>
    </div>
    <div class="page__full-width souvenir-full">
      <div class="page__min-container">
        <div class="text__normal">
          Металлическая роллерная ручка, покрытая белой эмалью <br>
          Тампопечать или УФ-печать, в зависимости от модели ручки
        </div>
      </div>
    </div>
    <div class="page__full-width souvenir-full m-zero">
      <div class="page__min-container m-zero">
        <div class="page__img-wrapper m-zero">
          <img src="~assets/img/souvenir-page/souvenier-4.png" alt="">
        </div>
      </div>
    </div>
    <div class="page__download-block ">
      <a class="main-btn_download"
         :href="all.urlZip"
         @click.prevent="downloadItemZip(all)">
        <svg  style="margin-right: 8px;" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="24" cy="24" r="16" stroke="white" stroke-linecap="round" stroke-dasharray="0.1 4"/>
          <path
              d="M23.6464 26.3536C23.8417 26.5488 24.1583 26.5488 24.3536 26.3536L27.5355 23.1716C27.7308 22.9763 27.7308 22.6597 27.5355 22.4645C27.3403 22.2692 27.0237 22.2692 26.8284 22.4645L24 25.2929L21.1716 22.4645C20.9763 22.2692 20.6597 22.2692 20.4645 22.4645C20.2692 22.6597 20.2692 22.9763 20.4645 23.1716L23.6464 26.3536ZM24.5 18L24.5 17.5L23.5 17.5L23.5 18L24.5 18ZM24.5 26L24.5 18L23.5 18L23.5 26L24.5 26Z"
              fill="white"/>
          <path d="M31 27V29C31 29.5523 30.5523 30 30 30H18C17.4477 30 17 29.5523 17 29V27" stroke="white"
                stroke-linecap="square"/>
        </svg>
        Скачать все макеты
      </a>
    </div>

    <div class="page-nav__tablet">
      <router-link class="next-page__link" to="/brand/clothes">
        <img src="~assets/img/icons/row-grey-small.svg" alt="prev">
        Одежда
      </router-link>
      <router-link class="next-page__link" to="/brand/event-decoration">
        Оформление мероприятий
        <img src="~assets/img/icons/row-grey-small.svg" alt="next">
      </router-link>
    </div>
    <div class="next-page">
      <router-link class="next-page__link" to="/brand/event-decoration">
        Оформление мероприятий
        <img src="~assets/img/icons/row-grey-small.svg" alt="next">
      </router-link>
    </div>
  </div>
</template>
<script>
import Axios from "axios";

export default {
  data() {
    return {
      all: {
        urlZip: '../dowload-file/Brand--Office/souvenir/Merch.zip',
        label: "Merch"
      },
      cup: {
        urlZip: '../dowload-file/Brand--Office/souvenir/GDP-Cup.zip',
        label: "GDP-Cup"
      },
      notebook: {
        urlZip: '../dowload-file/Brand--Office/souvenir/GDP-Notebook-A5.zip',
        label: "GDP-Notebook-A5"
      },
      usb: {
        urlZip: '../dowload-file/Brand--Office/souvenir/GDP-Usb.zip',
        label: "GDP-Usb"
      },
      pen: {
        urlZip: '../dowload-file/Brand--Office/souvenir/GDP-Pen.zip',
        label: "GDP-Pen"
      }
    }
  },
  methods: {
    downloadItemZip({urlZip, label}) {
      Axios.get(urlZip, {responseType: 'blob'})
          .then(response => {
            const blob = new Blob([response.data], {type: 'application/zip'})
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = label
            link.click()
            URL.revokeObjectURL(link.href)
          }).catch(console.error)
    },
  }
}
</script>
<style lang="scss" scoped>
@import "src/assets/style/page-block";
@import "src/assets/style/text-style";
@import "src/assets/style/buttons";

.page {
  margin-bottom: 192px;

  .page__full-width {
    .text__head {
      font-weight: 500;
    }

    &:first-child {
      .page__min-container {
        .text__head {
          margin-bottom: 0;
        }
      }
    }

    &:nth-child(2) {
      .page__link-block {
        margin-left: 20px;
        margin-top: -14px;

      }
    }

    &:nth-child(2) {
      .page__min-container {
        .text__normal {
          margin-top: -6px;
          margin-bottom: 31px;
        }
      }
    }
    &:nth-child(3) {
      .page__min-container {
        .text__normal {
          margin-bottom: 31px;
          max-width: 690px;

        }
      }

      .page__link-block {
        margin-left: 20px;
        margin-top: -6px;

      }
    }

    &:nth-child(4) {
      .page__min-container {
        .page__img-wrapper {
          margin-bottom: 92px;
        }
      }
    }

    &:nth-child(5) {
      .page__min-container {
        margin-bottom: 0;

        .text__head {
          margin-bottom: 0;
        }
      }

      .page__link-block {
        margin-left: 20px;
      }
    }

    &:nth-child(6) {
      .page__min-container {
        margin-bottom: -32px;

        .text__normal {
          margin-top: -4.5px;
        }
      }
    }

    &:nth-child(7) {
      .page__min-container {
        .page__img-wrapper {
          margin-bottom: 92px;
        }
      }
    }

    &:nth-child(8) {
      .page__min-container {
        margin-bottom: 15px;

        .text__head {
          margin-bottom: 0;
        }
      }

      .page__link-block {
        margin-left: 20px;
      }
    }

    &:nth-child(9) {
      .page__min-container {
        margin-bottom: -32px;

        .text__normal {
          margin-top: -5.5px;
        }
      }
    }

    &:nth-child(10) {
      .page__min-container {
        .page__img-wrapper {
          margin-bottom: 92px;
        }
      }
    }

    &:nth-child(11) {
      .page__min-container {
        margin-bottom: 13px;

        .text__head {
          margin-bottom: 0;
        }
      }

      .page__link-block {
        margin-left: 20px;
      }
    }

    &:nth-child(12) {
      .page__min-container {
        margin-bottom: 1px;

        .text__normal {
          margin-top: -5.5px;
          margin-bottom: 0;
        }
      }
    }
  }

  .main-btn_download {
    margin-top: 90px;
    letter-spacing: 0.85px;
    font-weight: 700;
    font-family: 'formular', serif;
  }
}

.blue {
  color: #000033;
}

.page__link-block {
  margin-left: 20px;
  display: flex;
}

.souvenir {
  display: flex;
  position: relative;

  &__title {
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: #39434D;
  }

  &__flesh {
    position: relative;

    &-title {
      position: absolute;
      top: 0;
      left: 0;
    }

    &-img-wap {
      width: 100%;
      max-width: 236px;

      img {
        width: 100%;
      }
    }
  }

  &__cup {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    &-wrap {
      margin-top: -150px;

      .page__link-block {
        align-items: center;
      }

      .souvenir__notebook-title {
        display: flex;
        align-items: flex-start;
      }
    }

    &-img-wap {
      width: 100%;
      max-width: 596px;

      img {
        width: 100%;
      }
    }
  }

  &__pen {
    display: flex;
    justify-content: flex-end;

    &-title {
      margin-right: 23%;
      margin-top: 18px;
    }

    &-wrap {
      position: absolute;
      margin-top: 26px;

      .page__link-block {
        z-index: 1;
      }
    }
  }

  &__notebook-and-pen {
    display: flex;

    &-img-wap {
      width: 100%;
      max-width: 720px;

      img {
        width: 100%;
      }
    }

    .souvenir__notebook-title {
      display: flex;
      align-items: flex-start;
    }

    &-wrap {
      .page__link-block {
        display: flex;
        align-items: center;
      }
    }
  }

  &__bag {
    &-title {
      position: absolute;
    }

    &-img-wap {
      width: 100%;

      img {
        width: 100%;
        margin-top: -19%;
      }
    }
  }
}

.souvenir-full {
  display: flex;
}

.page__img-wrapper {
  width: 100%;
}

.souvenir-min-margin {
  margin-bottom: 10px;
  display: flex;

}

.cup-block {
  .page__min-container {
    margin-bottom: 0;
  }
}

.m-zero {
  margin-bottom: 0;
}

sup {
  font-size: 10px;
  line-height: 1;
}

@media screen and (max-width: 1456px) {
  .page {
    margin-bottom: 208px;
  }
}

@media screen and (max-width: 1246px) {
  .page__download-block {
    display: none;
  }
}

@media screen and (max-width: 1216px) {
  .pages-wrap {
    .container {
      .page {
        .page__full-width {
          &.souvenir-full {
            width: 100%;
          }
          &:nth-child(5) {
            .page__min-container {
              .text__head {
                margin-bottom: 10px;
              }
            }
          }

          &:nth-child(6) {
            .page__min-container {
              .text__normal {
                margin-top: 0;
              }
            }
          }
        }
      }
    }
  }
  .souvenir__notebook-and-pen-wrap .page__link-block,
  .page__link-block {
    display: none;
  }
}

@media screen and (max-width: 768px) {
  .btn__gradient-main {
    display: none;
  }
  .souvenir__flesh-title {
    position: relative;
  }
  .souvenir__cup-wrap {
    margin-top: auto;
  }
  .page__min-container.souvenir__cup {
    flex-direction: column;
    align-items: flex-start;
  }
  .souvenir__cup-title.souvenir__title {
    position: relative;
  }
  .souvenir__flesh-img-wap {
    max-width: 100%;
  }
}

.text__normal {
  margin-bottom: 32px;
}

.cup-block .page__link-block .btn__circle {
  position: relative;
  top: 5px;
}
</style>
